@use 'variables' as *;
@use 'mixins' as *;
@use 'src/components/cat-form-hint/cat-form-hint';
@use 'utils/color';
@use '_snippets/form-label';

:host {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  @include cat-body('m');
}

:host([hidden]) {
  display: none;
}

.textarea-field,
.textarea-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 1 1 auto;
}

.textarea-field.textarea-horizontal {
  flex-direction: row;
  gap: 1rem;
}

.textarea-readonly {
  pointer-events: none;
}

.textarea-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
}

.icon-suffix {
  position: absolute;
  top: calc(0.625rem - 2px);
  right: 0.75rem;
  background: cat-token('color.ui.background.input', 0.75);
  border-radius: 100rem;

  .textarea-disabled & {
    background: cat-token('color.ui.background.muted', 0.75);
  }
}

textarea {
  margin: 0;
  padding: 0.625rem 0.75rem;
  box-sizing: border-box;
  min-height: form-label.$cat-input-height;
  font: inherit;
  background: cat-token('color.ui.background.input');
  border-radius: cat-border-radius('m');
  border: none;
  box-shadow: inset 0 0 0 1px rgb(var(--border-color));
  transition: box-shadow cat-token('time.transition.s') linear;
  resize: vertical;
  --border-color: #{cat-token('color.ui.border.dark', $wrap: false)};

  &:disabled {
    background: cat-token('color.ui.background.muted');
    cursor: not-allowed;
    color: cat-token('color.ui.font.muted');
    resize: none;
  }

  &:not(:disabled):hover {
    box-shadow:
      inset 0 0 0 1px rgb(var(--border-color)),
      0 0 0 1px rgb(var(--border-color));
  }

  &:focus {
    outline: 2px solid cat-token('color.ui.border.focus');
    outline-offset: -1px;
  }

  .textarea-invalid & {
    --border-color: #{cat-token('color.theme.danger.bg', 0.2, $wrap: false)};
  }

  &::placeholder {
    color: cat-token('color.ui.font.muted');
    opacity: 1;
  }

  /* stylelint-disable property-no-vendor-prefix */
  &:-webkit-autofill {
    &,
    &:hover,
    &:focus {
      -webkit-box-shadow: 0 0 0 9999px cat-token('color.ui.background.inputAutofill') inset;
    }
  }
  /* stylelint-enable property-no-vendor-prefix */
}
